import React from 'react'
import styled from 'styled-components';
import LogoImage from '../../atoms/Utlis/LogoImage';


const RefundAndRegister = () => {
    return (
        <Container>

            <HeaderContainer>
                <LogoImage />
            </HeaderContainer>
            <BodyContainer>

                <div className="policy-container">
                    {/* 1. Registration Policy */}
                    <div className="margin-bottom"><strong>1. Registration Policy</strong></div>

                    <div className="margin-bottom"><strong>Account Creation</strong></div>
                    <div className="margin-bottom">
                        Users must register with a valid email address, mobile number, and
                        password to access Kwikmedia services. Users are responsible for
                        maintaining the confidentiality of their login credentials.
                    </div>

                    <div className="margin-bottom"><strong>Eligibility</strong></div>
                    <div className="margin-bottom">
                        Users must be at least 18 years of age, or have parental/guardian
                        consent if younger. Accounts found with false or misleading information
                        may be suspended or terminated.
                    </div>

                    <div className="margin-bottom"><strong>Usage</strong></div>
                    <div className="margin-bottom">
                        Each account is personal and non-transferable. Users agree to comply
                        with Kwikmedia's Terms of Service and not misuse the platform.
                    </div>

                    {/* 2. Refund Policy */}
                    <div className="margin-bottom"><strong>2. Refund Policy</strong></div>
                    <div className="margin-bottom">
                        We aim to provide the best experience. However, if you are not satisfied
                        with our paid services, the following refund terms apply:
                    </div>

                    <div className="margin-bottom"><strong>Subscription Plans</strong></div>
                    <div className="margin-bottom">
                        Refunds are only available within 7 days of the initial subscription
                        purchase, provided no premium features (e.g., storage, editing tools,
                        face recognition scans) have been significantly used. Renewal payments
                        (auto-subscriptions) are non-refundable, but users may cancel
                        auto-renewal anytime from their account settings.
                    </div>

                    <div className="margin-bottom"><strong>Photo Storage & Premium Features</strong></div>
                    <div className="margin-bottom">
                        Fees paid for additional storage, AI-based features, or one-time credits
                        are non-refundable once the service has been consumed or credits used.
                        If purchased but unused, users may request a refund within 7 days of
                        purchase.
                    </div>

                    <div className="margin-bottom"><strong>Technical Issues</strong></div>
                    <div className="margin-bottom">
                        If a user experiences technical problems (e.g., payment failure,
                        duplicate charges), Kwikmedia will verify the issue and issue a refund or
                        credit within 7–10 business days.
                    </div>

                    <div className="margin-bottom"><strong>No Refunds For</strong></div>
                    <div className="margin-bottom">
                        Change of mind after purchase or violations of our Terms of Service
                        leading to account suspension or termination.
                    </div>

                    {/* 3. Refund Request Process */}
                    <div className="margin-bottom"><strong>3. Refund Request Process</strong></div>
                    <div className="margin-bottom">
                        To request a refund, users must contact{" "}
                        <a href="mailto:higcorona@gmail.com">higcorona@gmail.com</a> with
                        payment details, order ID, and reason for refund. Refunds will be
                        processed via the original payment method within 7–10 business days,
                        subject to verification.
                    </div>

                    {/* 4. Cancellation Policy */}
                    <div className="margin-bottom"><strong>4. Cancellation Policy</strong></div>
                    <div className="margin-bottom">
                        Users can cancel subscriptions from their account settings to prevent
                        future billing. If an account is deleted, users should export any data
                        they want to keep. Data deletion requests will be handled in accordance
                        with applicable laws.
                    </div>

                    {/* 5. Policy Updates */}
                    <div className="margin-bottom"><strong>5. Policy Updates</strong></div>
                    <div className="margin-bottom">
                        Kwikmedia reserves the right to update or modify this policy at any time.
                        Users will be notified of significant changes via email or in-app
                        notifications.
                    </div>
                </div>


            </BodyContainer>
        </Container >
    )
}

export default RefundAndRegister

const Container = styled.div`
padding:30px;
display:flex;
background: #F8EDFA;
position: relative;
overflow: hidden;
width: 100%;
flex-direction: column;
align-items: center;
justify-content: center;
`;

const HeaderContainer = styled.div``;

const BodyContainer = styled.div``;